import React from 'react'

const Fotter = () => {
  return (
  
    <div>
       
    <div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",paddingTop:"50px",paddingBottom:"100px",color:"white",backgroundColor:"#666666",lineHeight:"40px",fontFamily:"Verdana",paddingLeft:"30px"}}>
         {/* DIV-1 */}
        <div border={"2px solid red"} >
            <p>Bangalore</p>
            <p>Chennai</p>
            <p>Ahmedabad</p>
            <p>Mangalore</p>
            <p>Nagpur</p>
            <p>Bhopal</p>
            <p>Vadodara</p>
            <p>Madurai</p>
            <div style={{paddingTop:"5px"}}>
           <p style={{fontSize:"30px",lineHeight:"50px"}}>INDONESIA</p>
           <p>Jhakarta</p>
           </div>
          
        </div>
        {/* DIV-2 */}
        <div>
            <p>Pune</p>
            <p>Hyderabad</p>
            <p>Coimbatore</p>
            <p>Mysore</p>
            <p>Kochi</p>
            <p>Lucknow</p>
            <p>Nashik</p>
           <div style={{paddingTop:"45px",lineHeight:"50px"}}>
           <p style={{fontSize:"30px"}}>VIETNAM</p>
           <p>Ho Chi Minh</p>
           </div>
        </div>
        {/* <DIV-3> */}
        <div>
            <p>Delhi NCR</p>
            <p>Chandigarh</p>
            <p>Indore</p>
            <p> Vizag</p>
            <p>Vijayawada</p>
            <p>Guwahati</p>
            <p>Udupi-Manipal</p>
            <div style={{paddingTop:"45px"}}>
           <p style={{fontSize:"30px",lineHeight:"50px"}}>EGYPT</p>
           <p>Cairo</p>
           </div>
        </div>
        {/* <DIV-4> */}
        <div>
            <p>Mumbai</p>
            <p>Kolkata</p>
            <p>Kolkata</p>
            <p>Goa</p>
            <p>Siliguri</p>
            <p>Bhubaneswar</p>
            <p>Trichy</p>
        </div>
        {/* DIV-5 */}
        <div style={{fontSize:"70px",lineHeight:"70px",marginTop:"60px",marginLeft:"50px",color:"#a3a3a3"}}>
            <p>Never</p>
            <p>Stop</p>
            <p>Living</p>
            
        </div>
        {/* DIV-6 */}
        <div></div>
        {/* {DIV-7} */}
        <div style={{display:"flex",justifyContent:"space-around",marginTop:"80px",width:"400px",gap:"20px"}}>
            <div>
        <img   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAACZCAMAAAALgmiIAAAAElBMVEX///8AAADNzc2JiYlubm5AQEDv3d6lAAACpElEQVR4nO2b4XKEIAyEVeD9X7kjV9lLLiAIp7bu/oITt98wgITQaaIoiqIoiqIoiqKoM7XsCs2sF1pM2sDmXUXXsJbiG/JhaDEh2bPJgssoJNNYVWTpt1qTdjKXe+oNU5BJE58zcSQjGcisRRtkeBBHdZbMcOknM6Y5yILsqRyZZUIykh0lSwv8cjeyqLWG7ybJSDaIDB+H1+jfqteT4TXZeyT7+2ThLLLpc/+id0HY28e/K+MAaxc0jSEzpHaO86fUqmGJZCT7DWJ9Rm+R8FqNo/o16bZSaDFpJyvLOj1Ipduda5DslmQHT0PjcE9kXzkNPajUF2G/7bkiWbtOIFvCpzBcXap62QSTbq35nN0iTdrIijPcip0MhZxd986xl8zn7B5LNl1DBj9s0px0Bt4sS1CO+3qynEh2OzJsgHJpse+RAU/5KTypkBgRnqtYR5mcRYbeI9l/IkMwMJAMPC5nZSUpUJVOTpa6F4wymSfZA8iC4TSQzHKGHz6ZgFLVpNGnVBVk6vyMZH+CzAgQVagYY8hJVlP4+T2ysoo5FNV7quOvJFtIdhOyyuNCH7x/O198kaUmBtl6LLlNo63UBjbvSpnuv5BNfJDs2WS1KSOMdjTB+6nkhpy6H8zVTeI3FTuVT75IdnMyFW8OJ7NW/iJZbIcLCF5cR4vy210F30NWvq9hkaXusjwP9hTJnk2G5R/38VGSy/xbdN2RdG26sYTuMkzK6QqSkayaDPfP4rvpDrK+khxX/UiLJt8li2/MomRd3EP1jFWjkkwlYkh2GVlxF6TIcAdZ3soMmAbJZTk2DWp3jlaaTlWTrHQFyUhW82+E+AYUybwx7nsi4bL2c3VWdw3MUZPsIjJ80ftPZytPQ2sfSOMeMIqiKIqiKIqiKIrq0A/AwiaZAmuhDgAAAABJRU5ErkJggg==" alt="QR"  style={{width:"225px"}} />
        <p style={{lineHeight:"20px"}}>Scan this QR code to download app.</p>
        </div>
        <div style={{lineHeight:"35px",paddingLeft:"80px",padding:"10px 10px 10px 0px"}}>
         <p style={{fontSize:"30px"}}>DOWNLOAD ZOOMCAR APP</p>
         <p style={{lineHeight:"25px"}}>We have incredible offers,discounts & much more in our app.</p>
         
         <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXXNfHuAaJ77W6smxfAkhi75i8yuk2GsbjLzD6eX3BDw&usqp=CAU&ec=48600112" alt="" />
        </div>
        </div>

        

    </div>
    </div>
    </div>
  )
}

export default Fotter